import { action } from 'easy-peasy';
import { IResetCurrentDeleteRequestAction } from '../types';

const ISetDeleteRequestsAction: IResetCurrentDeleteRequestAction = action(state => {
  state.current = null;
});

export default ISetDeleteRequestsAction;
